import FormInputMobileNumberValidation from 'components/FormRegister/LogInDetails/components/FormInputMobileNumberValidation';
import FormInputValidation from 'components/FormRegister/LogInDetails/components/FormInputValidation';
import CustomSearchDropdown from 'components/common/CustomSearchDropdown/ver2';
import FormInputDisplayOnly from 'components/common/FormInputDisplayOnly';
import withCheckMobileNumber from 'features/to/HOCs/payment/withCheckMobileNumber';
import {
  FORM_ADD_PAYTO_ACCOUNT_VALIDATION_INITIAL,
  FORM_ADD_PAYTO_PAYID_EMAIL_FIELD,
  FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME,
  FORM_ADD_PAYTO_PAYID_MOBILE_FIELD,
  FORM_ADD_PAYTO_PAYID_TYPE_FIELD,
  FORM_ADD_PAYTO_PAYID_TYPE_NAME,
  PAYID_TYPE_MOBILE,
  PAYID_TYPE_OPTION_DATA,
  PAYTO_LOG_TAG,
  accountMobileConfig,
} from 'features/to/const';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import styled from 'styled-components';
import { displayFlexRowCenterCenterMixin } from 'styles';

const FormInputMobileNumber = withCheckMobileNumber(
  FormInputMobileNumberValidation
);
const FormInputEmail = withCheckMobileNumber(FormInputValidation);

const FormSelectionPayIdType = CustomSearchDropdown;

const FormInputEmailMobileValidation = ({
  paytoAccountInformation,
  setPaytoAccountInformation,
  paytoAccountValidation,
  setPaytoAccountValidation,
  paytoAccountInformationRetry,
  numberMaskStr,
  setNumberMaskStr,
  onPaytoSystemError,
  suppressPayIdMessage,
}) => {
  const { t } = useLang();

  const {
    isAccountAgreementEditing,
    payIdType,
    setPaytoPayIdType,
    paytoPayIdGeneration,
    setPaytoPayIdGeneration,
    setPaytoPayIdBankValidationFailure,
  } = usePaytoStore();
  const isPayIdTypeMobile = payIdType === PAYID_TYPE_MOBILE;

  const handlePayIdTypeOnChange = (payIdType) => {
    console.log(
      `⭐ ${PAYTO_LOG_TAG} 👉 handlePayIdTypeOnChange ➡️ payIdType ↩`,
      payIdType
    );

    setNumberMaskStr('');

    const newPaytoAccountInformation = {
      ...paytoAccountInformation,
      [FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME]: '',
      [FORM_ADD_PAYTO_PAYID_TYPE_NAME]: payIdType,
      // DEV-1401: this is a merge (spreads the prior paytoAccountInformation),
      // unlike the BSB<->PayID switch handlers which fully replace it -- so
      // these two must be cleared explicitly here or a stale confirmed
      // value/type from before the switch would survive it and could
      // incorrectly re-match a retyped value before any new validation runs.
      confirmedPayId: '',
      confirmedPayIdType: '',
    };
    console.log(
      `⭐ ${PAYTO_LOG_TAG} 👉 handlePayIdTypeOnChange ➡️ newPaytoAccountInformation ↩`,
      newPaytoAccountInformation
    );
    setPaytoAccountInformation(newPaytoAccountInformation);

    setPaytoAccountValidation(FORM_ADD_PAYTO_ACCOUNT_VALIDATION_INITIAL);

    // DEV-1401: a prior type's bank-validation-failure flag must not leak
    // across a mobile<->email switch and render the failure row before any
    // new validation has run for the freshly-selected type.
    setPaytoPayIdBankValidationFailure(false);

    // Bump the shared generation on every type switch so any validatePayId
    // request armed by the about-to-unmount mobile/email instance is
    // invalidated once it resolves, even though that instance itself is
    // gone by then (see withCheckMobileNumber.jsx).
    setPaytoPayIdGeneration((paytoPayIdGeneration || 0) + 1);
  };

  const renderFormSelectionPayIdType = () => {
    return (
      <FormSelectionPayIdType
        field={FORM_ADD_PAYTO_PAYID_TYPE_FIELD}
        data={PAYID_TYPE_OPTION_DATA}
        keyFind="key"
        keyTranslate="value"
        keyProp="key"
        information={paytoAccountInformation}
        setInformation={setPaytoAccountInformation}
        validation={paytoAccountValidation}
        setValidation={setPaytoAccountValidation}
        onChange={(item) => handlePayIdTypeOnChange(item?.key)}
        isSearchHidden
        scrollUp
        styles={{ marginBottom: 0 }}
        dropdownStyles={{ height: '44px', width: '120px' }}
        dropdownMenuContainerStyles={{
          transform: 'unset !important',
          inset: '0px auto auto -2px',
          minWidth: '120px',
          width: '120px',
        }}
        arrowDownIconColor="var(--ds-c-blue-hyperlink-default)"
      />
    );
  };
  const renderFormInputMobileEmail = () => {
    if (isPayIdTypeMobile)
      return (
        <FormInputMobileNumber
          field={FORM_ADD_PAYTO_PAYID_MOBILE_FIELD}
          config={accountMobileConfig}
          numberMaskStr={numberMaskStr}
          setNumberMaskStr={setNumberMaskStr}
          information={paytoAccountInformation}
          setInformation={setPaytoAccountInformation}
          validation={paytoAccountValidation}
          setValidation={setPaytoAccountValidation}
          rootStyles={{
            width: '100%',
            marginBottom: 0,
          }}
          onPaytoSystemError={onPaytoSystemError}
          suppressMessage={suppressPayIdMessage}
        />
      );
    return (
      <FormInputEmail
        field={FORM_ADD_PAYTO_PAYID_EMAIL_FIELD}
        information={paytoAccountInformation}
        setInformation={setPaytoAccountInformation}
        validation={paytoAccountValidation}
        setValidation={setPaytoAccountValidation}
        rootStyles={{
          width: '100%',
          marginBottom: 0,
        }}
        onPaytoSystemError={onPaytoSystemError}
        suppressMessage={suppressPayIdMessage}
      />
    );
  };

  const renderFormInput = () => {
    if (isAccountAgreementEditing)
      return (
        <FormInputDisplayOnly
          name={FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME}
          label="label_payid"
          value={
            paytoAccountInformation?.[FORM_ADD_PAYTO_PAYID_MOBILE_EMAIL_NAME]
          }
          styles={{
            marginBottom: 0,
          }}
          inputStyles={{
            background: '#ECECF0',
            border: '1px solid #DCE3F1',
          }}
        />
      );
    return (
      <FormInputEmailMobileValidationStyled>
        {renderFormSelectionPayIdType()}
        {renderFormInputMobileEmail()}
      </FormInputEmailMobileValidationStyled>
    );
  };

  return <>{renderFormInput()}</>;
};

const FormInputEmailMobileValidationStyled = styled.div`
  ${displayFlexRowCenterCenterMixin};
  align-items: end;
  gap: 12px;
  ${Fade};
`;

export default FormInputEmailMobileValidation;
